
<div>
    <div class=conSegFlex>
      
      <mat-form-field>
        <mat-label>Filter</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Search..." #input>
      </mat-form-field>
    </div>
      <div class="mat-elevation-z8 smooth" style="padding: 5px; position: relative; margin-left: 2%;margin-right: 2%;margin-bottom: 20px; width: 96%"
      >
        <mat-table 
          [dataSource]="users"   
          matSort
          >

          <ng-container matColumnDef="firstname">
            <mat-header-cell *matHeaderCellDef mat-sort-header style="max-width: 100px">First Name</mat-header-cell>
            <mat-cell *matCellDef="let row"  style="max-width: 100px"> {{row.firstname}} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="lastname">
            <mat-header-cell *matHeaderCellDef mat-sort-header style="max-width: 100px" >Last Name</mat-header-cell>
            <mat-cell *matCellDef="let row" style="max-width: 100px"> {{row.lastname}} </mat-cell>
          </ng-container>
        

          <ng-container matColumnDef="currentLesson">
            <mat-header-cell *matHeaderCellDef mat-sort-header style="max-width: 100px"> Lesson </mat-header-cell>
            <mat-cell *matCellDef="let row" style="max-width: 100px"> {{row.currentLesson}} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="lastUpdated">
            <mat-header-cell *matHeaderCellDef mat-sort-header style="max-width: 200px"> Last Active </mat-header-cell>
            <mat-cell *matCellDef="let row" style="max-width: 200px"> {{row.lastUpdated  | date}} </mat-cell>
          </ng-container>
          <ng-container matColumnDef="createdAt">
            <mat-header-cell *matHeaderCellDef mat-sort-header style="max-width: 200px"> Creation Date </mat-header-cell>
            <mat-cell *matCellDef="let row" style="max-width: 200px"> {{row.createdAt  | date}} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="c">
            <mat-header-cell *matHeaderCellDef> Completed </mat-header-cell>
            <mat-cell *matCellDef="let row"> 
              <div *ngIf="!!row?.conf" class=lcflex>
                <div 
                
                style="margin: 2px;"
                class=conf
                [ngClass]="{  'true': c.response === 'true', 
                'false': c.response !== 'true'}"
                *ngFor="let c of row.conf;" >{{cards[c?.index -1]?.topic}}</div>
              </div>  
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="options">
            <mat-header-cell *matHeaderCellDef> Options</mat-header-cell>
            <mat-cell *matCellDef="let row">
              <button mat-stroked-button (click)="openProfileSheet($event, row)">:::::::</button>
            </mat-cell>
        
          </ng-container>
        
          <!-- Header and Row Declarations -->
          <mat-header-row  *matHeaderRowDef="['firstname', 'lastname', 'currentLesson', 'lastUpdated','createdAt', 'c', 'options']"></mat-header-row>
          <mat-row  *matRowDef="let row; columns: ['firstname', 'lastname', 'currentLesson', 'lastUpdated','createdAt','c', 'options']"></mat-row>
        </mat-table>
        <mat-paginator [pageSizeOptions]="[15, 25, 50, 100]"></mat-paginator>
      </div>
  </div>

